















import { defineComponent } from "@vue/composition-api";
import { Button } from "@micad/vue-components/src/main";
import router from "@/router";
import config from "@/config";
import Loading from "@/components/Loading.vue";

export default defineComponent({
  components: {
    Button,
    Loading,
  },
  setup() {
    return {
      query: router.currentRoute.query,
      goToHub() {
        window.location.href = config.DEFAULT_REDIRECT_URL || "/";
      },
    };
  },
});
